import { servicesData, allServices } from './servicesData';
import { Link } from 'react-router-dom';
// import logo from './images/logo.png';
const Footer = () => {
  return (
    <footer className="bg-[#bdbbbb] relative text-black pt-10 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10 items-start">
          
          <div className="flex flex-col">
            <h3 className="text-xl font-bold mb-4">ABOUT US</h3>
           <img src="/logo2.png" alt="Environature Logo" className="w-40 h-12 mb-4" />
            <p className="text-sm">
            Environature Solution is dedicated to delivering tailored, high-impact solutions to a diverse clientele. With a commitment to excellence, integrity, and client satisfaction, we bring expertise in various industries including waste management, electronics, IT/telecom, steel and iron, chemicals.
            </p>
          </div>

          {/* Services Column */}
          <div className="h-full min-h-[220px] flex flex-col">
            <h3 className="text-xl font-bold mb-4">Services</h3>
            <marquee behavior="scroll" direction="up" scrollAmount="2" height="180px">
              <ul className="space-y-3 text-sm leading-relaxed">
                {allServices.map((service, index) => (
                  <li key={index}>
                    <Link 
                      to={`/services#${service.slug}`} 
                      className="hover:text-green-700 transition-colors"
                    >
                      {service.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </marquee>
          </div>

          {/* Quick Links Column */}
          {/* Combined Quick Links + Social Connection Column */}
<div className="flex flex-col">
  <h4 className="text-xl font-bold mb-4">Quick Links</h4>
  <ul className="space-y-3 text-sm mb-6">
    <li><Link to="/about" className="hover:text-green-700">About Us</Link></li>
    <li><Link to="/contact" className="hover:text-green-700">Contact</Link></li>
  </ul>

  <h4 className="text-xl font-bold mb-4">Social Connection</h4>
  <div className="flex space-x-5">
    <a href="/" target="_blank" rel="noopener noreferrer" className="text-black hover:text-green-700 transition">
      <i className="fab fa-facebook-f text-xl"></i>
    </a>
    <a href="/" target="_blank" rel="noopener noreferrer" className="text-black hover:text-green-700 transition">
      <i className="fab fa-linkedin-in text-xl"></i>
    </a>
    <a href="/" target="_blank" rel="noopener noreferrer" className="text-black hover:text-green-700 transition">
      <i className="fab fa-instagram text-xl"></i>
    </a>
    <a href="/" target="_blank" rel="noopener noreferrer" className="text-black hover:text-green-700 transition">
      <i className="fab fa-twitter text-xl"></i>
    </a>
    <a href="/" target="_blank" rel="noopener noreferrer" className="text-black hover:text-green-700 transition">
      <i className="fab fa-youtube text-xl"></i>
    </a>
  </div>
</div>


          {/* Contact Column */}
          <div className="h-full min-h-[220px] flex flex-col">
            <div>
              <h3 className="text-xl font-bold mb-4">Our Address</h3>
              <h4 className="font-semibold mb-2" itemProp="name">Environature Solution</h4>
              <div itemProp="address">
                <p className="text-sm mb-4">
                  <a
                    href="https://maps.app.goo.gl/mXdsT5eid2SLakrv5"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-green-700 transition-colors inline-block"
                  >
                    <i className="fas fa-map-marker-alt text-black mr-2"></i>
                    <span itemProp="streetAddress">Bldg no. 2, Nalanda SRA CHSL, Office no. F 4 , 1st floor,</span><br />
                    <span itemProp="addressLocality">Jawahar Rd, behind Suchita Business Park,</span><br />
                    <span itemProp="addressRegion">Ghatkopar East, Mumbai, Maharashtra</span><br />
                    PIN - <span itemProp="postalCode">400077</span>
                  </a>
                </p>
                <p className="text-sm mb-2 flex items-center">
                  <i className="fas fa-envelope text-black mr-2"></i>
                  <a href="mailto:info@environaturesolution.com" className="hover:text-green-700">info@environaturesolution.com</a>
                </p>
                <p className="text-sm flex items-center">
                  <i className="fas fa-phone-alt text-black mr-2"></i>
                  <a href="tel:+91-9326897902" className="hover:text-green-700">+91-9326897902</a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center text-sm border-t border-white pt-6">
          © {new Date().getFullYear()} Environature Solution. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
